
export const watchlistTypes = {
    VIEW_WATCHLIST: 'VIEW_WATCHLIST',
    VIEW_WATCHLIST_ERROR: 'VIEW_WATCHLIST_ERROR',
};
